"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateLootShopCategoryResponseToJSON = exports.CreateLootShopCategoryResponseFromJSONTyped = exports.CreateLootShopCategoryResponseFromJSON = void 0;
var _1 = require("./");
function CreateLootShopCategoryResponseFromJSON(json) {
    return CreateLootShopCategoryResponseFromJSONTyped(json, false);
}
exports.CreateLootShopCategoryResponseFromJSON = CreateLootShopCategoryResponseFromJSON;
function CreateLootShopCategoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': (0, _1.MenuCategoryFromJSON)(json['category']),
    };
}
exports.CreateLootShopCategoryResponseFromJSONTyped = CreateLootShopCategoryResponseFromJSONTyped;
function CreateLootShopCategoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': (0, _1.MenuCategoryToJSON)(value.category),
    };
}
exports.CreateLootShopCategoryResponseToJSON = CreateLootShopCategoryResponseToJSON;
